<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/monitor")
            i.fa.fa-eye
            span.ml-1 {{ $t("ui.monitor") }}
        b-breadcrumb-item
          router-link(to="/monitor/asidebar")
            i.fa.fa-signal
            span.ml-1 {{ $t("ui.status") }}
    b-card(body-class="p-1").p-0
      div(slot="header")
        div.row
          div.col-md-1
            SubmitButton(:loading="loading" icon="icon-reload" :text="$t('ui.refresh')" @click="getReportList" size="sm" variant="info")
          div.col-md-3
            b-input-group(size="sm").mb-1
              b-input-group-text(slot="prepend")
                div.d-flex.justify-content-center.align-items-center
                  label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                    input.switch-input(type="checkbox" v-model="$options.refreshEnabled" @change="toggleRefresh()")
                    span.switch-slider(:data-checked='on' :data-unchecked='off')
              b-input(v-model="refreshTime" type="range" min="3" max="10")
              b-input-group-text(slot="append")
                div(style="text-transform: none;") {{ refreshTime }} s
          div.col-md-2
            b-input-group(size="sm").mb-1
              b-input-group-text(slot="prepend")
                span {{ $t('ui.alert') }}
              b-input-group-text(slot="append")
                div.d-flex.justify-content-center.align-items-center
                  label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                    input.switch-input(type="checkbox" v-model="alert")
                    span.switch-slider(:data-checked='on' :data-unchecked='off')
      b-tabs(small card)
        b-tab(title-link-class="small-link" title-item-class="small-item")
          template(slot="title")
            span(style="padding: 1px; line-height: 16px;") {{ $t("ui.status") }}
          //- div.row.mb-3
          //-   div.col-6
          //-     table.table(style="width: 100%;")
          //-       thead
          //-         tr
          //-           th
          //-             span URL
          //-           th
          //-             span {{ $t("ui.status") }}
          //-       tbody
          //-         tr(v-for="(item, index) in hostList")
          //-           td
          //-             span {{ index }}
          //-           td(:class="{ 'blink' : item != 'ok' }")
          //-             span.font-weight-bold.text-uppercase {{ item }}
          div.row
            div.col-6
              b-form-group(:label="$t('ui.sbo')").mb-3
                .clusterize-scroll(style="max-height: 550px;")
                  table.tablex(style="width: 100%;" v-columns-resizable)
                    thead
                      tr
                        th.sticky-position(@click="sortOrder('bot_id', 'status')")
                          span {{ $t('ui.id') }}
                          i(:class="changeSortKey('bot_id', 'status')")
                        th.sticky-position(@click="sortOrder('bot_name', 'status')")
                          span {{ $t('ui.name') }}
                          i(:class="changeSortKey('bot_name', 'status')")
                        th.sticky-position(@click="sortOrder('bot_status', 'status')")
                          span {{ $t('ui.status') }}
                          i(:class="changeSortKey('bot_status', 'status')")
                    tbody.clusterize-content
                      tr(v-if="filteredSBOBotList.length == 0")
                        td(colspan="3").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="item in filteredSBOBotList")
                        td
                          span.font-weight-bold.text-uppercase {{ item.bot_id }}
                        td
                          span(:title="item.bot_name") {{ item.bot_name }}
                        td(:class="classObject(getBotStatus(item.bot_id, 'SBO'), 'status')")
                          span.font-weight-bold.text-uppercase {{ getBotStatus(item.bot_id, 'SBO').result }}
            div.col-6
              b-form-group(:label="$t('ui.ibc')").mb-3
                .clusterize-scroll(style="max-height: 550px;")
                  table.table(style="width: 100%;" v-columns-resizable)
                    thead
                      tr
                        th.sticky-position(@click="sortOrder('bot_id', 'status')")
                          span {{ $t('ui.id') }}
                          i(:class="changeSortKey('bot_id', 'status')")
                        th.sticky-position(@click="sortOrder('bot_name', 'status')")
                          span {{ $t('ui.name') }}
                          i(:class="changeSortKey('bot_name', 'status')")
                        th.sticky-position(@click="sortOrder('bot_status', 'status')")
                          span {{ $t('ui.status') }}
                          i(:class="changeSortKey('bot_status', 'status')")
                    tbody.clusterize-content
                      tr(v-if="filteredIBCBotList.length == 0")
                        td(colspan="3").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="item in filteredIBCBotList")
                        td
                          span.font-weight-bold.text-uppercase {{ item.bot_id }}
                        td
                          span(:title="item.bot_name") {{ item.bot_name }}
                        td(:class="classObject(getBotStatus(item.bot_id, 'IBC'), 'status')")
                          span.font-weight-bold.text-uppercase {{ getBotStatus(item.bot_id, 'IBC').result }}
        //- b-tab(title-link-class="small-link" title-item-class="small-item")
        //-   template(slot="title")
        //-     span(style="padding: 1px; line-height: 16px;") {{ $t("ui.account") }}
        //-   div.row(v-if="userList")
        //-     div.col-6
        //-       .clusterize-scroll(style="max-height: 550px;")
        //-         table.tablex(style="width: 100%;")
        //-           thead
        //-             tr
        //-               th.sticky-position(style="width: 100px;")
        //-                 span {{ $t("ui.providerid") }}
        //-               th.sticky-position(style="width: 160px;" @click="sortOrder('account_id', 'account')")
        //-                 span {{ $t("ui.username") }}
        //-                 i(:class="changeSortKey('account_id', 'account')")
        //-               th.sticky-position(style="width: 160px;" @click="sortOrder('bot_id', 'account')")
        //-                 span {{ $tc("ui.bots", 1) }}
        //-                 i(:class="changeSortKey('bot_id', 'account')")
        //-               th.sticky-position(@click="sortOrder('state', 'account')")
        //-                 span {{ $t("ui.status") }}
        //-                 i(:class="changeSortKey('state', 'account')")
        //-           tbody.clusterize-content
        //-             tr(v-if="filteredIBCUserList.length == 0")
        //-               td(colspan="4").text-center
        //-                 span {{ $t('message.no_data_available') }}
        //-             tr(v-for="(item, index) in filteredIBCUserList" v-if="item")
        //-               td
        //-                 span {{ item.provider_id }}
        //-               td
        //-                 span {{ item.account_id }}
        //-               td
        //-                 span {{ getBotId(item.account_id)}}
        //-               td(:class="classObject(item, 'account')")
        //-                 span.font-weight-bold.text-uppercase {{ item.state }}
        //-     div.col-6
        //-       .clusterize-scroll(style="max-height: 550px;")
        //-         table.tablex(style="width: 100%;")
        //-           thead
        //-             tr
        //-               th.sticky-position(style="width: 100px;")
        //-                 span {{ $t("ui.providerid") }}
        //-               th.sticky-position(style="width: 160px;" @click="sortOrder('account_id', 'account')")
        //-                 span {{ $t("ui.username") }}
        //-                 i(:class="changeSortKey('account_id', 'account')")
        //-               th.sticky-position(style="width: 160px;" @click="sortOrder('bot_id', 'account')")
        //-                 span {{ $tc("ui.bots", 1) }}
        //-                 i(:class="changeSortKey('bot_id', 'account')")
        //-               th.sticky-position(@click="sortOrder('state', 'account')")
        //-                 span {{ $t("ui.status") }}
        //-                 i(:class="changeSortKey('state', 'account')")
        //-           tbody.clusterize-content
        //-             tr(v-if="filteredSBOUserList.length == 0")
        //-               td(colspan="4").text-center
        //-                 span {{ $t('message.no_data_available') }}
        //-             tr(v-for="(item, index) in filteredSBOUserList" v-if="item")
        //-               td
        //-                 span {{ item.provider_id }}
        //-               td
        //-                 span {{ item.account_id }}
        //-               td
        //-                 span {{ getBotId(item.account_id) }}
        //-               td(:class="classObject(item, 'account')")
        //-                 span.font-weight-bold.text-uppercase {{ item.state }}
        b-tab(v-for="(report, index) in reportList" :title="index" title-link-class="small-link" title-item-class="small-item" :key="index" @click="setTab(index)")
          template(slot="title")
            span(style="padding: 1px; line-height: 16px;") {{ index }}
            b-badge(variant="danger" size="sm" style="width: 25px; vertical-align: top;").ml-1 {{ report.length }}

          div.d-flex.flex-wrap
            div.clusterize
              div.form-row.mb-2
                div.col-sm-9.col-md-6
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.icon-magnifier
                    DebounceInput(required type="text" v-model="reportSearch" :placeholder="$t('message.search_by_id_name')")
                div.col-sm-3.col-md-1.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="id") {{ $tc("ui.bots", 1) }}
                    b-form-radio(value="username") {{ $t("ui.username") }}
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width=200 @click="sortOrder('bot_id', 'provider')")
                        span {{ $tc('ui.bots', 1) }}
                        i(:class="changeSortKey('bot_id', 'provider')")
                      th.sticky-position(width=200 @click="sortOrder('date_time', 'provider')")
                        span {{ $t('ui.time') }}
                        i(:class="changeSortKey('date_time', 'provider')")
                      th.sticky-position(width=400 @click="sortOrder('bot_model', 'provider')")
                        span {{ $t('ui.model') }}
                        i(:class="changeSortKey('bot_model', 'provider')")
                      th.sticky-position(width=150 @click="sortOrder('username', 'provider')")
                        span {{ $t('ui.username') }}
                        i(:class="changeSortKey('username', 'provider')")
                      th.text-center.sticky-position(width=120 @click="sortOrder('action', 'provider')")
                        span {{ $t("ui.action") }}
                        i(:class="changeSortKey('action', 'provider')")
                      th.text-center.sticky-position(@click="sortOrder('result', 'provider')")
                        span {{ $t("ui.result") }}
                        i(:class="changeSortKey('result', 'provider')")
                      th.sticky-position(width=50 style="z-index: 10;")
                        span
                  tbody.clusterize-content
                    tr(v-for="item in filteredReportList")
                      td
                        span.font-weight-bold.text-uppercase(:title="item.bot.id") {{ item.bot.id }}
                      td
                        span {{ item.date_time.replace("T", " ") }}
                      td
                        span.font-weight-bold.text-info(:title="item.bot.model") {{ item.bot.model }}
                      td
                        span.font-weight-bold.text-info {{ item.target.username }}
                      td.actions(:class="{ 'blink': item.payload.action.toLowerCase() == 'logout' }")
                        span.font-weight-bold.text-primary.text-uppercase {{ item.payload.action }}
                      td.actions(:class="classObject(item, 'provider')")
                        span.font-weight-bold.text-uppercase(:title="item.payload.result") {{ item.payload.result }}
                      td.actions
                        span
                          a.fa.fa-eye.text-primary(href="#" @click="getMoreInfo(item, $event)" :title="$t('ui.view')")

      bot(ref="bot" :selectedBot="selectedBot")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import _ from "lodash";
import bot from "@/components/status/bot.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    bot,
    DebounceInput
  },
  data() {
    return {
      loading: false,
      loginSearch: "",
      hostList: [],
      userList: [],
      reportList: null,
      sboBotList: [],
      ibcBotList: [],
      loginIdStr: "'",
      loginBotList: [],
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      selectedBot: null,
      timerId: null,
      refreshTime: 5,
      refreshUpdate: "",
      filterBy: "id",
      reportSearch: "",
      currTab: "status",
      providerSortKey: "result",
      providerSortType: "asc",
      accountSortKey: "state",
      accountSortType: "asc",
      statusSortKey: "bot_status",
      statusSortType: "asc"
      // providerSortKey: "date_time",
      // providerSortType: "desc",
      // accountSortKey: "account_id",
      // accountSortType: "asc",
      // statusSortKey: "bot_status",
      // statusSortType: "asc"
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    alert:
    {
      get() {
        return this.$store.getters.alertOn;
      },
      set(value) {
        this.changedAlertOn(value);
      }
    },
    filteredSBOBotList() {
      return this.sboBotList.filter(function(obj) {
        return obj.bot_disabled == false;
      })
      .sort((a, b) => {
        if (this.statusSortType == 'asc') {
          if (this.statusSortKey == 'bot_id') return a.bot_id > b.bot_id ? 1 : -1;
          else if (this.statusSortKey == 'bot_name') return a.bot_name > b.bot_name ? 1 : -1;
          else if (this.statusSortKey == 'bot_status')
            return (this.getBotStatus(a.bot_id, a.provider_id).success === this.getBotStatus(b.bot_id, b.provider_id).success) ?
                    (this.getBotStatus(a.bot_id, a.provider_id).result > this.getBotStatus(b.bot_id, b.provider_id).result ? 1 : -1) : this.getBotStatus(a.bot_id, a.provider_id).success ? 1 : -1;
          // else if (this.statusSortKey == 'bot_status') return this.getBotStatus(a.bot_id, a.provider_id).result > this.getBotStatus(b.bot_id, b.provider_id).result ? 1 : -1;
        } else if (this.statusSortType == 'desc') {
          if (this.statusSortKey == 'bot_id') return a.bot_id < b.bot_id ? 1 : -1;
          else if (this.statusSortKey == 'bot_name') return a.bot_name < b.bot_name ? 1 : -1;
          else if (this.statusSortKey == 'bot_status')
            return (this.getBotStatus(a.bot_id, a.provider_id).success === this.getBotStatus(b.bot_id, b.provider_id).success) ?
            (this.getBotStatus(a.bot_id, a.provider_id).result < this.getBotStatus(b.bot_id, b.provider_id).result ? 1 : -1) : !this.getBotStatus(a.bot_id, a.provider_id).success ? 1 : -1;
          // else if (this.statusSortKey == 'bot_status') return this.getBotStatus(a.bot_id, a.provider_id).result < this.getBotStatus(b.bot_id, b.provider_id).result ? 1 : -1;
        }
      });
    },
    // filteredSBOBotList() {
    //   var list = this.reportList;
    //   if (list && list['SBO'] && list instanceof Object) {
    //     return this.sboBotList.filter(function(obj) {
    //       return !list['SBO'].some(function(obj2) {
    //         return obj.bot_id == obj2.bot.id && obj.bot_disabled == false;
    //       });
    //     });
    //   } else
    //     return [];
    // },
    filteredIBCBotList() {
      return this.ibcBotList.filter(function(obj) {
        return obj.bot_disabled == false;
      })
      .sort((a, b) => {
        if (this.statusSortType == 'asc') {
          if (this.statusSortKey == 'bot_id') return a.bot_id > b.bot_id ? 1 : -1;
          else if (this.statusSortKey == 'bot_name') return a.bot_name > b.bot_name ? 1 : -1;
          else if (this.statusSortKey == 'bot_status')
            return (this.getBotStatus(a.bot_id, a.provider_id).success === this.getBotStatus(b.bot_id, b.provider_id).success) ?
            (this.getBotStatus(a.bot_id, a.provider_id).result > this.getBotStatus(b.bot_id, b.provider_id).result ? 1 : -1) : this.getBotStatus(a.bot_id, a.provider_id).success ? 1 : -1;
          // else if (this.statusSortKey == 'bot_status') return this.getBotStatus(a.bot_id, a.provider_id).result > this.getBotStatus(b.bot_id, b.provider_id).result ? 1 : -1;
        } else if (this.statusSortType == 'desc') {
          if (this.statusSortKey == 'bot_id') return a.bot_id < b.bot_id ? 1 : -1;
          else if (this.statusSortKey == 'bot_name') return a.bot_name < b.bot_name ? 1 : -1;
          else if (this.statusSortKey == 'bot_status')
            return (this.getBotStatus(a.bot_id, a.provider_id).success === this.getBotStatus(b.bot_id, b.provider_id).success) ?
            (this.getBotStatus(a.bot_id, a.provider_id).result < this.getBotStatus(b.bot_id, b.provider_id).result ? 1 : -1) : !this.getBotStatus(a.bot_id, a.provider_id).success ? 1 : -1;
          // else if (this.statusSortKey == 'bot_status') return this.getBotStatus(a.bot_id, a.provider_id).result < this.getBotStatus(b.bot_id, b.provider_id).result ? 1 : -1;
        }
      });
    },
    // filteredIBCBotList() {
    //   var list = this.reportList;
    //   if (list && list['IBC'] && list instanceof Object) {
    //     return this.ibcBotList.filter(function(obj) {
    //       return !list['IBC'].some(function(obj2) {
    //         return obj.bot_id == obj2.bot.id && obj.bot_disabled == false;
    //       });
    //     });
    //   } else
    //     return [];
    // },
    filteredSBOUserList() {
      return this.userList.filter((item) => {
        return item.provider_id == 'SBO';
      })
      .sort((a, b) => {
        if (this.accountSortType == 'asc') {
          if (this.accountSortKey == 'account_id') return a.account_id > b.account_id ? 1 : -1;
          // else if (this.accountSortKey == 'state') return a.state > b.state ? 1 : -1;
          else if (this.accountSortKey == 'state') return (a.state === b.state) ? 0 : a.state == 'ok' ? 1 : -1;
          else if (this.accountSortKey == 'bot_id') return a.bot_id > b.bot_id ? 1 : -1;
        } else if (this.accountSortType == 'desc') {
          if (this.accountSortKey == 'account_id') return a.account_id < b.account_id ? 1 : -1;
          // else if (this.accountSortKey == 'state') return a.state < b.state ? 1 : -1;
          else if (this.accountSortKey == 'state') return (a.state === b.state) ? 0 : a.state != 'ok' ? 1 : -1;
          else if (this.accountSortKey == 'bot_id') return a.bot_id < b.bot_id ? 1 : -1;
        }
      });
    },
    filteredIBCUserList() {
      return this.userList.filter((item) => {
        return item.provider_id == 'IBC';
      })
      .sort((a, b) => {
        if (this.accountSortType == 'asc') {
          if (this.accountSortKey == 'account_id') return a.account_id > b.account_id ? 1 : -1;
          // else if (this.accountSortKey == 'state') return a.state > b.state ? 1 : -1;
          else if (this.accountSortKey == 'state') return (a.state === b.state) ? 0 : a.state == 'ok' ? 1 : -1;
          else if (this.accountSortKey == 'bot_id') return a.bot_id > b.bot_id ? 1 : -1;
        } else if (this.accountSortType == 'desc') {
          if (this.accountSortKey == 'account_id') return a.account_id < b.account_id ? 1 : -1;
          // else if (this.accountSortKey == 'state') return a.state < b.state ? 1 : -1;
          else if (this.accountSortKey == 'state') return (a.state === b.state) ? 0 : a.state != 'ok' ? 1 : -1;
          else if (this.accountSortKey == 'bot_id') return a.bot_id < b.bot_id ? 1 : -1;
        }
      });
    },
    filteredReportList() {
      if (this.currTab == "IBC" ||  this.currTab == "SBO") {
        return this.reportList[this.currTab].filter(item => {
          if (this.filterBy == "username") {
            return item.target.username.toLowerCase().indexOf(this.reportSearch.toLowerCase()) > -1;
          } else {
            return item.bot.id.toLowerCase().indexOf(this.reportSearch.toLowerCase()) > -1;
          }
        })
        .sort((a, b) => {
          if (this.providerSortType == 'asc') {
            if (this.providerSortKey == 'bot_id') return a.bot.id > b.bot.id ? 1 : -1;
            else if (this.providerSortKey == 'date_time') return a.date_time.replace("T", " ") > b.date_time.replace("T", " ") ? 1 : -1;
            else if (this.providerSortKey == 'bot_model') return a.bot.model > b.bot.model ? 1 : -1;
            else if (this.providerSortKey == 'username') return a.target.username > b.target.username ? 1 : -1;
            else if (this.providerSortKey == 'action') return a.payload.action > b.payload.action ? 1 : -1;
            // else if (this.providerSortKey == 'result') return a.payload.result > b.payload.result ? 1 : -1;
            else if (this.providerSortKey == 'result') return (a.payload.success === b.payload.success) ? (a.payload.result > b.payload.result ? 1 : -1) : a.payload.success ? 1 : -1;
          } else if (this.providerSortType == 'desc') {
            if (this.providerSortKey == 'bot_id') return a.bot.id < b.bot.id ? 1 : -1;
            else if (this.providerSortKey == 'date_time') return a.date_time.replace("T", " ") < b.date_time.replace("T", " ") ? 1 : -1;
            else if (this.providerSortKey == 'bot_model') return a.bot.model < b.bot.model ? 1 : -1;
            else if (this.providerSortKey == 'username') return a.target.username < b.target.username ? 1 : -1;
            else if (this.providerSortKey == 'action') return a.payload.action < b.payload.action ? 1 : -1;
            // else if (this.providerSortKey == 'result') return a.payload.result < b.payload.result ? 1 : -1;
            else if (this.providerSortKey == 'result') return (a.payload.success === b.payload.success) ? (a.payload.result < b.payload.result ? 1 : -1) : !a.payload.success ? 1 : -1;

          }
        });
      }
//!item.payload.success
      return [];
    }
  },
  created: function() {
    this.$options.refreshEnabled = false;
  },
  mounted: function() {
    this.getReportList();
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    changedAlertOn: function(eventStatus) {
      this.$store.dispatch("user/setAlertOn", eventStatus);
    },
    classObject(item, type) {
      if (type == 'provider') {
        if (!item.payload.success)
          return 'blink';
        else if (item.payload.result.toLowerCase() == 'ok' || item.payload.result.toLowerCase() == 'success')
          return 'green-bg';
        else
          return 'blue-bg';
      } else if (type == 'account') {
        if (item.state != 'ok')
          return 'blink';
        else
          return 'green-bg';
      } else if (type == 'status') {
        if (!item.success)
          return 'red-bg';
        else if (item.result.toLowerCase() == 'not_open')
          return 'yellow-bg';
        else if (item.result.toLowerCase() == 'ok' || item.result.toLowerCase() == 'success')
          return 'green-bg';
        else
          return 'blue-bg';
        // if (item.toLowerCase() == 'ok' || item.toLowerCase() == 'success')
        //   return 'green-bg';
        // else if (item.toLowerCase() == 'not open')
        //   return 'red-bg';
        // else
        //   return 'blue-bg';
      }

    },
    sortOrder(key, type) {
      if (type == 'provider') {
        if (this.providerSortKey == key)
          this.providerSortType = this.providerSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.providerSortKey = key;
          this.providerSortType = 'asc';
        }
      } else if (type == 'account') {
        if (this.accountSortKey == key)
          this.accountSortType = this.accountSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.accountSortKey = key;
          this.accountSortType = 'asc';
        }
      } else if (type == 'status') {
        if (this.statusSortKey == key)
          this.statusSortType = this.statusSortType == 'asc' ? 'desc' : 'asc';
        else {
          this.statusSortKey = key;
          this.statusSortType = 'asc';
        }
      }
    },
    changeSortKey(key, type) {
      if (type == 'provider') {
        if (this.providerSortKey != key)
          return 'fas fa-sort';
        else if (this.providerSortKey == key && this.providerSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.providerSortKey == key && this.providerSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'account') {
        if (this.accountSortKey != key)
          return 'fas fa-sort';
        else if (this.accountSortKey == key && this.accountSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.accountSortKey == key && this.accountSortType == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'status') {
        if (this.statusSortKey != key)
          return 'fas fa-sort';
        else if (this.statusSortKey == key && this.statusSortType == 'asc')
          return 'fa fa-sort-up';
        else if (this.statusSortKey == key && this.statusSortType == 'desc')
          return 'fa fa-sort-down';
      }
    },
    setTab: function(index) {
      this.currTab = index;
    },
    getBotStatus(bot_id, provider) {
      if (this.reportList[provider]) {
        if (this.reportList[provider].filter(item => { return item.bot.id == bot_id; }).length > 0)
          return this.reportList[provider].filter(item => { return item.bot.id == bot_id; })[0].payload;
        else
          return { "result": "not_open", "success": true };
      }
      else
        return { "result": "not_open", "success": true };
    },
    getBotId(account_id) {
      if (this.loginBotList.filter(item => { return item.login_id == account_id; }).length > 0)
        return this.loginBotList.filter(item => { return item.login_id == account_id; })[0].bot_id;
      else
        return '';
    },
    getBotList: function(provider) {
      let url = config.botListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.status,
        bot_id: "",
        bot_name: "",
        provider_id: provider
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if (provider == 'SBO') {
                  //this.sboBotList = response.data.tbl_bot_list;
                  this.sboBotList = response.data.ds.bot;
                  // this.sboBotList.sort((a, b) => {  });
                }
                else if (provider == 'IBC')
                  this.ibcBotList = response.data.ds.bot;
                  // this.ibcBotList = response.data.tbl_bot_list;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getReportList: function() {
      let url = config.statusListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.status
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.hostList = response.data.hosts;
                this.userList = response.data.users;
                //testing
                // console.log(this.userList);
                // for(var i = 0; i < this.userList.length; i++) {
                //   if(i % 2 == 0)
                //     this.userList[i].state = "unknown";
                // }
                this.reportList = response.data.reports;
                this.reportList = _.orderBy(this.reportList, ["payload.success", "bot.id"], ["asc"]);
                this.reportList = _.groupBy(this.reportList, "target.provider_id");
                this.getBotList('SBO');
                this.getBotList('IBC');
                // this.getBotByLoginId();
                // console.log(this.reportList);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            if (!this.feedback.status.includes('No connection is available to service this operation'))
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          if (!this.feedback.status.includes('No connection is available to service this operation'))
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getBotByLoginId: function() {
      let url = config.getBotByLoginIdUrl();

      this.loginIdStr = "'";

      this.loginIdStr = this.loginIdStr + this.userList.map(e => e.account_id).join("', '") + "'";

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.status,
        login_id_str: this.loginIdStr
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.loginBotList = response.data.tbl_login_bot_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            if (!this.feedback.status.includes('No connection is available to service this operation'))
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          if (!this.feedback.status.includes('No connection is available to service this operation'))
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    toggleRefresh: function() {
      this.startCountDownRefresh();
    },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        this.getReportList();
        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();
        }, this.refreshTime * 1000);
      } else {
        this.refreshUpdate = "STOPPED";
      }
    },
    getMoreInfo: function(item, event) {
      this.selectedBot = item;
      this.$refs.bot.$refs.bot.show();
    },
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD, HH:mm:ss a");
      return convertDateFormat;
    }
  }
};
</script>

<style lang="scss">
.small-item {
  margin-top: 8px !important;
}

.small-link {
  border-top: 1px solid rgba(0, 0, 0, 0) !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.active.small-link {
  border-top: 1px solid rgb(216, 210, 222) !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.blink {
  -webkit-animation: blinking 1.5s ease infinite; /* Safari 4+ */
  -moz-animation: blinking 1.5s ease infinite; /* Fx 5+ */
  -o-animation: blinking 1.5s ease infinite; /* Opera 12+ */
  animation: blinking 1.5s ease infinite; /* IE 10+, Fx 29+ */
}

.blue-bg {
  background-color: rgb(207, 231, 238) !important;
  color: #456f8b;
}

.green-bg {
  background-color: #B0E3D1 !important;
  color: #486C76;
}

.red-bg {
  background-color: lightcoral !important;
}

.yellow-bg {
  background-color: #EEF9BF !important;
  color: #6A8CAF;
}

tr, td {
  cursor: pointer;
}

@keyframes blinking {
  0% {
    background-color: rgba(255, 255, 255, 0);
    color: rgb(211, 98, 143);
  }
  50% {
    background-color: rgb(211, 98, 143);
    color: #ffffff;
  }
  100% {
    background-color: rgba(255, 255, 255, 0);
    color: rgb(211, 98, 143);
  }
}
</style>